import { areNotEqual, isStringEmpty } from "@/common/validation-checkers";
import IGuest from "@/models/guests/iguest";

export function GuestHasRequiredFormFields(guest: IGuest) {
    
    if (!guest) {
        return false;
    }
    
    if (
        !isStringEmpty(guest.firstName) &&
        !isStringEmpty(guest.lastName)
    ) {
        return true;
    }

    return false;
}

export function GuestHasFormData(guest: IGuest) {

    if (!guest) {
        return false;
    }

    if (
        isStringEmpty(guest.firstName) &&
        isStringEmpty(guest.lastName) &&
        isStringEmpty(guest.emailAddress) &&
        isStringEmpty(guest.phoneNumber) &&
        isStringEmpty(guest.dietaryRequirements) &&
        isStringEmpty(guest.notes)
    ) {
        return false;
    }

    return true;
}

export function GuestHasChanged(original: IGuest, revised: IGuest) {

    if (!original || !revised) {
        return false;
    }

    if (
        areNotEqual(original.firstName, revised.firstName) ||
        areNotEqual(original.lastName, revised.lastName) ||
        areNotEqual(original.emailAddress, revised.emailAddress) ||
        areNotEqual(original.phoneNumber, revised.phoneNumber) ||
        areNotEqual(original.dietaryRequirements, revised.dietaryRequirements) ||
        areNotEqual(original.notes, revised.notes) ||
        areNotEqual(original.isInstructor, revised.isInstructor)
    ) {
        return true;
    }
    else {
        return false;
    }
}